export const environment = {
  production: true,
  apiURL: 'https://dv07.athena.ushe-ords.io/api/v1',
  redirect_uri: 'https://dv07.athena.ushe-ords.io/auth/login',
  oAuthClientId: '142452478274-7rknnft2n74a84bmnd8k7hqstr6gpd46.apps.googleusercontent.com',
};
